import classNames from 'classnames'
import type { SyntheticEvent } from 'react'
import { useCallback } from 'react'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import type { State } from 'store/types'

import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { changeChannelsType } from './actions'
import type { ChannelsType } from './types'
import useStyles from './useStyles'

function ChannelsTabs() {
  const { t: translate } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()
  const channelsType = useSelector((state: State) => state.channelsType)
  const resetChannel = useCallback(() => dispatch(changeChannelsType()), [dispatch])
  const handleChange = useCallback(
    (event: SyntheticEvent, newChannelsType: ChannelsType) => {
      event.stopPropagation()
      dispatch(changeChannelsType(newChannelsType))
    },
    [dispatch],
  )

  return (
    <Tabs
      classes={{ indicator: classes.indicator, root: classes.root }}
      onChange={handleChange}
      onClick={resetChannel}
      value={channelsType}
    >
      <Tab
        className={classNames(classes.tab, { [classes.active]: channelsType === 'channels' })}
        value="channels"
        label={translate('channelsTabs.channels')}
      />
      <Tab
        className={classNames(classes.tab, { [classes.active]: channelsType === 'saleTypes' })}
        value="saleTypes"
        label={translate('channelsTabs.saleTypes')}
      />
      <Tab
        className={classNames(classes.tab, { [classes.active]: channelsType === 'countries' })}
        value="countries"
        label={translate('channelsTabs.countries')}
      />
      {/* Hide, will be available for next release 
        <Tab
          className={classNames(classes.tab, { [classes.active]: channelsType === 'owners' })}
          value="owners"
          label={translate('channelsTabs.owners')}
        />
      */}
    </Tabs>
  )
}

export default memo(ChannelsTabs)
